import React from "react";
import styles from "./styles";
import { MarkdownReader } from "../../MarkdownReader";

type RecordCardProps = {
  comment: string;
  date: string;
  emotion: string;
  icon?: React.ReactNode;
  advice?: string;
};

export function RecordCard({
  comment,
  date,
  emotion,
  icon,
  advice,
}: RecordCardProps) {
  return (
    <div style={styles.card}>
      <div style={styles.indicatorsContainer}>
        <div style={styles.emotionContainer}>
          {icon && <p style={styles.iconWrapper}>{icon}</p>}
          <p style={styles.emotionText}>{emotion}</p>
        </div>
        <p style={styles.dateText}>{date}</p>
      </div>
      <p style={styles.commentText}>{comment}</p>
      {advice && (
        <>
          <hr style={styles.separator} />
          <MarkdownReader>
            {advice}
          </MarkdownReader>
        </>
      )}
    </div>
  );
}
